import { NeedsAssessmentWizardStep } from 'Components/Pages/NeedsAssessment/constants'
import { GoalCategory, UserSurveyRole } from 'Generated/graphql-types'

const config = { domain: 'Account', subdomain: 'NeedsAssessment' }

interface PriorityCompleted {
  userRole: UserSurveyRole | undefined
  rank: number
  category: GoalCategory
  confidenceLevel: number
  challenges: string
  nestedTopics: string[]
  userId: number
  nonprofitOrgId: number
  userEmail: string
}

interface StepTransitionData {
  currentStep: NeedsAssessmentWizardStep
  nextStep: NeedsAssessmentWizardStep
  userId: number
  nonprofitOrgId: number
  funderOrgId: number | null
  userEmail: string
  userJourneyLength: number
  userRole: UserSurveyRole | undefined
}

interface MissionStatement {
  userId: number
  nonprofitOrgId: number
  userEmail: string
  missionStatement: string
}

export const needsAssessment = {
  Priority_Completed: {
    Priority_Completed: (param: PriorityCompleted) => param,
    config,
  },
  NA_Survey_Step_Transition: {
    NA_Survey_Step_Transition: (param: StepTransitionData) => param,
  },

  Mission_Skipped: {
    Mission_Skipped: (param: MissionStatement) => param,
    config,
  },

  Mission_Added: {
    Mission_Added: (param: MissionStatement) => param,
    config,
  },
}
